var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicationBubbleChatCommentTalkSpeechIconSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79925 18.2267L5.2 20.4999L5.83064 16.5169C4.33462 15.138 3.5 13.2227 3.5 11.1052C3.5 6.90497 6.78398 3.5 12 3.5C17.216 3.5 20.5 6.90497 20.5 11.1052C20.5 15.3054 17.216 18.7104 12 18.7104C10.831 18.7104 9.75897 18.5394 8.79925 18.2267Z",
    stroke: "#9393B0",
    strokeWidth: 1.88888,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationBubbleChatCommentTalkSpeechIconSvgrepocom);
export default __webpack_public_path__ + "static/media/communication-bubble-chat-comment-talk-speech-icon_svgrepo.com.2787c53bb72dcc641781ed1f0a32d7bf.svg";
export { ForwardRef as ReactComponent };